import { useGetComponentsQuery, ComponentInfoFragment } from 'gqlTypes'

// This is a valid use case to narrow down Component type
// eslint-disable-next-line no-restricted-imports
import { ColorVariable } from 'gqlTypes/expansiveTypes'

import { rgba } from 'polished'

import { useGetIdentifiers } from './useGetIdentifiers'

interface RgbaColor {
  red: number
  green: number
  blue: number
  alpha: number
}

const isColorVariableComponent = (
  component?: ComponentInfoFragment
): component is ColorVariable => component?.__typename === 'ColorVariable'

export const useGetColorVariables = (search?: string) => {
  const { shareIdentifier, versionShortId } = useGetIdentifiers()
  const { loading, data, refetch, fetchMore } = useGetComponentsQuery({
    variables: {
      shareIdentifier,
      versionShortId,
      type: 'COLOR_VARIABLE',
      search,
    },
  })

  return {
    loading,
    filter: (path: string | null) => refetch({ path }),
    fetchMore,
    entries:
      data?.share?.version?.document?.components.entries
        .filter(isColorVariableComponent)
        .map(color => ({
          ...color,
          rgbaValue: rgba(color.rgbaValue as RgbaColor),
          alpha: color.rgbaValue.alpha,
        })) || [],
    meta: data?.share?.version?.document?.components.meta,
  }
}
